import { render } from "./EditProduit.vue?vue&type=template&id=7b02632f&scoped=true&ts=true"
import script from "./EditProduit.vue?vue&type=script&lang=ts"
export * from "./EditProduit.vue?vue&type=script&lang=ts"

import "./EditProduit.vue?vue&type=style&index=0&id=7b02632f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b02632f"]])

export default __exports__